import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   max-width: 480px;
   width: 100%;

   .webhook-section {
      margin-bottom: 12px;
   }

   .webhook-section h4 {
      margin: 0 0 6px 0;
      color: #333;
      font-size: 16px;
      font-weight: 600;
   }

   .link-container {
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 8px;
      background: #f9f9f9;
      cursor: pointer;
      max-width: 100%;
      overflow: hidden;
   }

   .link-with-copy {
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0;
   }

   .copy-icon {
      color: #666;
      font-size: 12px;
      flex-shrink: 0;
   }

   .copy-icon.copied {
      color: #10b981;
   }

   .link-text {
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 14px;
      color: #333;
      word-break: break-all;
      overflow-wrap: break-word;
      white-space: normal;
      min-width: 0;
      flex: 1;
   }

   .instructions-section {
      margin: 12px 0;
   }

   .instructions-section h5 {
      margin: 0 0 8px 0;
      color: #333;
      font-size: 14px;
      font-weight: 600;
   }

   .steps-list {
      margin: 0;
      padding-left: 16px;
      font-size: 14px;
      line-height: 1.4;
   }

   .steps-list li {
      margin-bottom: 6px;
   }

   .steps-list li a {
      color: #0066cc;
      text-decoration: none;
   }

   .steps-list li a:hover {
      text-decoration: underline;
   }

   .external-link {
      color: #262627;
      text-decoration: none;
      font-size: 14px;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      margin-top: 8px;
   }

   .external-link:hover {
      text-decoration: underline;
   }

   .typeform-logo {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      color: #262627;
      font-weight: 500;
      margin-bottom: 8px;
   }
`;

export const Loader = styled.span`
   width: 68px;
   height: 68px;
   border: 5px solid #9ca3af;
   border-bottom-color: #262627;
   border-radius: 50%;
   display: block;
   box-sizing: border-box;
   animation: rotation 1s linear infinite;
   margin: 0 auto;

   @keyframes rotation {
      0% {
         transform: rotate(0deg);
      }
      100% {
         transform: rotate(360deg);
      }
   }
`;